export default {
	SET_MESSAGE_RECIPIENT_LIST(state, payload) {
		state.list = payload;
	}, SET_RECEIVED_INBOX_FILTER(state, payload) {
		state.filter.received = payload;
	}, SET_SENT_INBOX_FILTER(state, payload) {
		state.filter.sent = payload;
	}, SET_MESSAGE_RECIPIENT_RESPONSIBLE(state, payload) {

		payload.forEach((value) => {
			value.formatedName = value.name;
		});

		state.responsible = payload;

	}, SET_MESSAGE_RECIPIENT_SCHOOLMEMBERS(state, payload) {

		payload.forEach((value) => {
			value.formatedName = `${ value.name } (${ value.role })`;
		});

		state.schoolMembers = payload;

	}, SET_MESSAGE_RECEIVED_LIST(state, payload) {
		state.messages.received = payload;
	}, SET_MESSAGE_SENT_LIST(state, payload) {
		state.messages.sent = payload;
	}, SET_MESSAGES_AGENDA_LIST(state, payload) {
		state.inboxAgenda = payload;
	}, PUT_MESSAGE_RESPONSIBLE(state, payload) {
		state.compose = payload;
	}, PUT_MESSAGE_SCHOOLMEMBERS(state, payload) {
		state.compose.schoolMembers = payload;
	}, PUT_MESSAGE_SUBJECT(state, payload) {
		state.compose.subject = payload;
	}, PUT_MESSAGE_MESSAGE(state, payload) {
		state.compose.message = payload;
	}, SET_MESSAGE_GROUP(state, payload) {
		state.messageGroup = payload;
	}, SET_RECIPIENTS_SELECTED(state, payload) {
		state.compose.push(payload);
	}, PUT_UNREAD_MESSAGES(state, payload) {
		state.unreadMessages = payload;
	}
};



// WEBPACK FOOTER //
// ./sources/app/inbox/mutations.js